import {environment} from "../../../../environments/environment";

function createUrl(actionName: string): string {
  return `${environment.apiBaseUrl}${environment.apiUrl}${environment.apiVersion}${actionName}`;
}

export const TermApiResources = {
  list:  createUrl('terms'),
  byModule: createUrl('terms/by-module'),
  create:  createUrl('terms/create'),
  detail:  createUrl('terms'),
  update:  createUrl('terms'),
  delete:  createUrl('terms'),
};
